__turbopack_context__.v({
  "header": "Header-module-sass-module__rtjpvq__header",
  "logo": "Header-module-sass-module__rtjpvq__logo",
  "logo-text": "Header-module-sass-module__rtjpvq__logo-text",
  "mail": "Header-module-sass-module__rtjpvq__mail",
});
